var map = {
	"./carousel_item_azts.png": 77323,
	"./carousel_item_cwjz.png": 777,
	"./carousel_item_gclqd.png": 54119,
	"./carousel_item_gcsj.png": 80045,
	"./carousel_item_gjfw.png": 63059,
	"./carousel_item_jjbzx.png": 86775,
	"./carousel_item_jjfa.png": 31375,
	"./carousel_item_jsbzx.png": 92164,
	"./carousel_item_pjbl.png": 64140,
	"./carousel_item_rkjba.png": 29285,
	"./carousel_item_sbyw.png": 61171,
	"./carousel_item_spzz.png": 13012,
	"./carousel_item_swbzx.png": 10697,
	"./carousel_item_tbsb.png": 83765,
	"./carousel_item_twsj.png": 74351,
	"./carousel_item_xcbm.png": 12395,
	"./carousel_item_xckc.png": 48893,
	"./carousel_item_xmgl.png": 75569,
	"./carousel_item_xqgt.png": 83779,
	"./carousel_item_xsbf.png": 59356,
	"./carousel_item_zjscc.png": 76989,
	"./carousel_item_zlbx.png": 12273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42389;